module.exports = __webpack_public_path__ + "static/media/user-alt.492ddda5.svg";